import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable, Subject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { IUserGroup } from "../_models/IUserGroup";
import { IUserGroupQueryOptions } from "../_models/IUserGroupQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class UserGroupService {
    userGroupSubject = new Subject<IUserGroup[]>();
    private cacheName: string = "userGroupsCache";

    constructor(private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService) { }

    getUserGroups(options: IUserGroupQueryOptions = {}, invalidateCache = false): Observable<IUserGroup[]> {
        if (options) {
            return this.getUserGroupsFromDb(options);
        }

        return this.dataCacheService.getOrRequest(this.cacheName, () => this.getUserGroupsFromDb(), { invalidateCache }).pipe(map(groups => this.sortGroupsByDescription(groups)));
    }

    getUserGroupsFromDb(options: IUserGroupQueryOptions = {}): Observable<IUserGroup[]> {
        return this.http.get<IUserGroup[]>('/api/usergroup', { params: options as HttpParams }).pipe(map(groups => this.sortGroupsByDescription(groups)));
    }

    saveUserGroup(group: IUserGroup): Observable<IUserGroup> {
        return this.http.post<IUserGroup>('/api/usergroup', group).pipe(
            tap(group => {
                this.dataCacheService.addOrUpdateItem(group, this.cacheName);
            }));
    }

    private sortGroupsByDescription(groups: IUserGroup[]): IUserGroup[] {
        groups.sort((a, b) => a.Description < b.Description ? -1 : 1);
        return groups;
    }
}
